import { Component, ElementRef, EventEmitter, Host, OnDestroy, OnInit, Output, ViewChild } from "@angular/core";
import { Plan, Sku } from "@brain/data";
import { ApiService } from "projects/brain/src/app/services";
import { map, switchMap, take } from "rxjs/operators";
import { AssetDetailComponent } from "../asset-detail";
import { AssetDetailSectionDirective } from "../asset-section";

@Component({
    selector: "brain-asset-details-purchase",
    templateUrl: "./purchase.html",
    styleUrls: ["./purchase.scss"]
})
export class AssetDetailPurchaseComponent extends AssetDetailSectionDirective implements OnInit, OnDestroy {

  public key = "Purchase Plans";

  @ViewChild("paymentPlans")
  targetEl: ElementRef;

  @Output()
  skuChanged: EventEmitter<Sku> = new EventEmitter();

  @Output()
  planChanged: EventEmitter<Plan> = new EventEmitter();

  public skus: Sku[] = [];

  public plans: Plan[] = [];

  public activeSku: Sku;

  constructor(
      private apiService: ApiService,
      @Host() assetDetail: AssetDetailComponent,
      el: ElementRef,
  ) {
      super(assetDetail, el);
  }

  public ngOnInit(): void {

      super.ngOnInit();

      this.assetDetail.productDetail$
          .pipe(
              switchMap((details) => this.apiService.getSkus(details.detail.product_id, this.assetDetail.catalog)),
              map((skus) => skus.sort((a, b) => a.rank - b.rank)),
              take(1)
          )
          .subscribe((skus) => this.skus = skus);
  }

  /**
   * select a sku and put to cart
   *
   */
  public activateSku(sku: Sku): void {

      if (this.activeSku === sku) {
          this.activeSku = null;
          this.plans = [];
          return;
      }

      /** load available plans */
      this.assetDetail.productDetail$
          .pipe(
              switchMap((details) => this.apiService.getSkuPlans(details.detail.product_id, sku.sku_id, this.assetDetail.catalog)),
              map((plans) => plans.sort((a, b) => a.rank < b.rank ? 1 : 0)),
              take(1)
          )
          .subscribe((plans) => this.plans = plans);

      this.skuChanged.emit(sku);
      this.activeSku = sku;
  }

  /**
   * select plan
   *
   */
  public selectPlan(plan: Plan): void {
      this.planChanged.emit(plan);
  }
}
